export const MESSAGES = {
  somethingwrong: 'Something went wrong',
};
